import { useEffect, useMemo, useState } from 'react';

import { useAccountStatus, useHasAnyAllowedRole } from '@src/packages/utils';

import { BILLING_NOTICE_ROLES } from '../../../constants';
import { type AccountBanner, getAccountBanner } from '../../../utils/getAccountBanner';

/** The trial countdown is in days: an hourly clock keeps a long-open tab accurate. */
export const BANNER_CLOCK_INTERVAL_MS = 60 * 60 * 1000;

export const useAccountStatusBanner = (): AccountBanner | null => {
  const { snapshot, loaded } = useAccountStatus();
  const isBillingContact = useHasAnyAllowedRole(BILLING_NOTICE_ROLES);
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), BANNER_CLOCK_INTERVAL_MS);
    return () => clearInterval(timer);
  }, []);

  return useMemo(
    () => (loaded ? getAccountBanner(snapshot, isBillingContact, now) : null),
    [isBillingContact, loaded, now, snapshot],
  );
};
